<script setup>

const props = defineProps({
  data: Object,
  pulseData: Object,
  gridData: Object
});
const ageValue = toRef(props, 'pulseData');
const ageData = toRef(props, 'gridData');

const selectedAge = ref(null);
const emit = defineEmits(['nestedStep', 'validateStep']);
// Extract ages from props data
const ages = props.data.ages
  .map((item) => {
    const ageRange = item.courseRecAge.split(":")[1].trim().split("-");
    return [...Array(parseInt(ageRange[1]) - parseInt(ageRange[0]) + 1).keys()].map(
      (i) => parseInt(ageRange[0]) + i
    );
  })
  .flat();

// Define the hasSteps function
const hasSteps = (ageRange) => {
  return ageRange && ageRange.step && Array.isArray(ageRange.step.blocks) && ageRange.step.blocks.length > 0;
};

const toggleAge = (age) => {
  const currentYear = new Date().getFullYear(); // Get the current year
// Calculate the year of birth
  selectedAge.value = age;
  
  emit("validateStep", {
    value: currentYear - selectedAge.value,
    component: props.data.component
  });
  ageValue.value.students[0].studentBirthYear =  currentYear - selectedAge.value
  ageData.value.age = selectedAge.value

  // Find the selected age range directly
  const selectedAgeRange = props.data.ages.find(ageRange => {
    const [startAge, endAge] = ageRange.courseRecAge.split(":")[1].trim().split("-").map(Number);
    return age >= startAge && age <= endAge;
  });

  // If a matching age range is found, emit its steps if available, otherwise emit false
  if (selectedAgeRange) {
    emit("nestedStep", hasSteps(selectedAgeRange) ? selectedAgeRange.step : false);
  } else {
    // If no matching age range is found, emit false
    emit("nestedStep", false);
  }
};

onMounted(() => {
  const parentElement = document.getElementById('age-relations').parentElement.parentElement.parentElement
  
  const observer = new MutationObserver((mutationsList, observer) => {
    for (var mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'style' && parentElement.style.display !== 'none') {
        emit('validateStep', {
          value: selectedAge.value,
          component: props.data.component
        });
      }
    }
  });
  observer.observe(parentElement, { attributes: true});
})
</script>

<template>
  <div class="age-select btn-wrapper btn-group" id="age-relations">
    <button
      v-for="age in ages"
      :key="age"
      class="btn-quiz"
      :class="{ active: selectedAge === age }"
      @click="toggleAge(age)"
    >
      <span v-if="selectedAge === age" class="bi-check"></span>
      <span v-else class="space"></span>
      <span>{{ age }}</span>
    </button>
  </div>
</template>

<style lang="scss" scoped>
$breakpoint-xs-max: 400px;
.age-select .btn-quiz {
  min-width: 100px;
  padding: 0px 35px 0px 10px;

  @include media-breakpoint-down($breakpoint-xs-max) {
    min-width: 90px;
  }
}
</style>
